import React from "react";

export default function ContactPage() {
  return (
    <div>
      <h2>Contact</h2>
      <p>Association office, helpdesk, security, housekeeping, and facility manager.</p>
    </div>
  );
}